import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'
import { offlineDB } from '../services/offlineDB'
import { obtenerRecargoEquivalencia } from '../utils/recargoEquivalencia'
import { generarPDFFactura, guardarPDFEnSupabase } from '../utils/pdfGenerator'
import { exportarFacturasAExcel, exportarFacturaIndividualAExcel } from '../utils/excelGenerator'
import { enviarFacturaVeriFactu, enviarLoteVeriFactu, verificarBackendVeriFactu } from '../services/verifactuAPI'
import { imprimirFactura } from '../utils/printer'
import { prepararArchivosGestoria } from '../utils/gestoriaUtils'
import FacturaIndividual from '../components/FacturaIndividual'
import { enviarFacturasAGestoria, enviarFacturaACliente } from '../utils/emailService'
import TotalesSemanaAnterior from '../components/TotalesSemanaAnterior'
import { 
  FileText, Plus, Download, Mail, Printer, CheckCircle, 
  XCircle, AlertTriangle, RefreshCw, FileSpreadsheet, Calendar, Send, Package
} from 'lucide-react'
import jsPDF from 'jspdf'

export default function Facturacion() {
  const [facturas, setFacturas] = useState([])
  const [facturasPendientes, setFacturasPendientes] = useState([])
  const [sincronizaciones, setSincronizaciones] = useState([])
  const [configuracion, setConfiguracion] = useState(null)
  const [loading, setLoading] = useState(false)
  const [filtro, setFiltro] = useState('todas')
  const [mostrarGeneracion, setMostrarGeneracion] = useState(false)
  const [backendActivo, setBackendActivo] = useState(false)
  const [enviandoVeriFactu, setEnviandoVeriFactu] = useState(false)
  const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([])
  const [mostrarProgresoCompleto, setMostrarProgresoCompleto] = useState(false)
  const [progresoInfo, setProgresoInfo] = useState(null)
  const [mostrarTotalesSemana, setMostrarTotalesSemana] = useState(false)
  const [mostrarFacturaIndividual, setMostrarFacturaIndividual] = useState(false)

  function toggleSeleccion(id) {
    setFacturasSeleccionadas(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    )
  }

  function seleccionarTodas() {
    if (facturasSeleccionadas.length === facturasFiltradas.length) {
      setFacturasSeleccionadas([])
    } else {
      setFacturasSeleccionadas(facturasFiltradas.map(f => f.id))
    }
  }

  // ========== ACCIÓN MASIVA MEJORADA ==========
  async function accionMasiva(accion) {
    if (facturasSeleccionadas.length === 0) {
      alert('Selecciona al menos una factura')
      return
    }
    
    const facturasSelec = facturas.filter(f => facturasSeleccionadas.includes(f.id))
    
    switch (accion) {
      case 'descargar':
        const opcion = confirm(
          `¿Cómo deseas descargar las ${facturasSelec.length} facturas?\n\n` +
          `OK = Todas juntas en un PDF\n` +
          `Cancelar = Por separado`
        )
        
        if (opcion) {
          await descargarTodasJuntas(facturasSelec)
        } else {
          for (const factura of facturasSelec) {
            await descargarPDF(factura)
          }
          alert(`${facturasSelec.length} facturas descargadas`)
        }
        break
        
      case 'gestoria':
        if (!configuracion?.email_gestoria) {
          alert('⚠️ No hay email de gestoría configurado.\nVe a Configuración para establecerlo.')
          return
        }
        
        if (!confirm(`¿Enviar ${facturasSelec.length} facturas a gestoría?`)) return
        
        try {
          setLoading(true)
          console.log(`Preparando ${facturasSelec.length} facturas para gestoría...`)
          
          // Usar la función mejorada con Excel + PDF único
          const archivos = await prepararArchivosGestoria(facturasSelec, generarPDFFactura)
          
          console.log('Archivos preparados, enviando email...')
          
          // CORRECCIÓN: Usar función correcta sin "Mejorado"
          await enviarFacturasAGestoria(
            facturasSelec,
            archivos,
            configuracion.email_gestoria
          )
          
          await cargarFacturas()
          
          alert(
            `✅ ENVIADO A GESTORÍA\n\n` +
            `${facturasSelec.length} facturas\n` +
            `Email: ${configuracion.email_gestoria}\n\n` +
            `Adjuntos:\n` +
            `• ${archivos.nombreExcel}\n` +
            `• ${archivos.nombrePdf}`
          )
          
        } catch (error) {
          console.error('Error completo:', error)
          alert(`❌ ERROR AL ENVIAR\n\n${error.message}`)
        } finally {
          setLoading(false)
        }
        break
        
      case 'imprimir':
      try {
        setLoading(true)
        const resultado = await imprimirFacturasMasivo(facturasSelec)
        
        if (resultado.fallidas > 0) {
          alert(`⚠️ IMPRESIÓN COMPLETADA\n\n✅ Exitosas: ${resultado.exitosas}\n❌ Fallidas: ${resultado.fallidas}`)
        } else {
          alert(`✅ ${resultado.exitosas} facturas impresas correctamente`)
        }
      } catch (error) {
        console.error('Error imprimiendo:', error)
        alert('❌ Error al imprimir: ' + error.message)
      } finally {
        setLoading(false)
      }
      break
        
      case 'clientes':
        try {
          setLoading(true)
          
          const facturasConEmail = facturasSelec.filter(f => f.cliente_email)
          
          if (facturasConEmail.length === 0) {
            alert('⚠️ Ninguna de las facturas seleccionadas tiene email de cliente')
            return
          }
          
          let enviadas = 0
          let errores = 0
          
          for (const factura of facturasConEmail) {
          try {
            console.log('🔍 Generando PDF para:', factura.serie, factura.numero);
            const pdfDoc = await generarPDFFactura(factura, configuracion)
            
            // ✅ CAMBIAR ESTAS LÍNEAS
            // ANTES:
            // const blob = pdfDoc.output('blob')
            
            // DESPUÉS:
            const pdfBytes = pdfDoc.output('arraybuffer')
            const blob = new Blob([pdfBytes], { type: 'application/pdf' })
            
            console.log('🔍 Blob generado:', blob instanceof Blob);
            console.log('🔍 Blob tamaño:', blob?.size, 'bytes');
            
            await enviarFacturaACliente(factura, blob)
            enviadas++
          } catch (error) {
            console.error(`Error con ${factura.serie}-${factura.numero}:`, error)
            errores++
          }
        }
          
          await cargarFacturas()
          
          alert(
            `RESULTADO ENVÍO A CLIENTES:\n\n` +
            `✅ Enviadas: ${enviadas}\n` +
            `❌ Errores: ${errores}\n` +
            `⏭️  Sin email: ${facturasSelec.length - facturasConEmail.length}`
          )
          
        } catch (error) {
          alert('Error: ' + error.message)
        } finally {
          setLoading(false)
        }
        break
    }
    
    setFacturasSeleccionadas([])
  }

  async function descargarTodasJuntas(facturasSelec) {
    try {
      setLoading(true)
      
      const formatoA4 = confirm(
        `¿Qué formato deseas?\n\n` +
        `OK = A4 (normal)\n` +
        `Cancelar = Térmica 80mm`
      )
      
      const formato = formatoA4 ? 'a4' : 'termica'
      
      const primerDoc = await generarPDFFactura(facturasSelec[0], configuracion, { formato })
      const pdf = new jsPDF(
        formato === 'termica' ? {
          orientation: 'portrait',
          unit: 'mm',
          format: [80, 297]
        } : undefined
      )
      
      for (let i = 0; i < facturasSelec.length; i++) {
        const factura = facturasSelec[i]
        const doc = await generarPDFFactura(factura, configuracion, { formato })
        
        if (i === 0) {
          Object.assign(pdf, doc)
        } else {
          const pdfPages = doc.internal.getNumberOfPages()
          for (let j = 1; j <= pdfPages; j++) {
            pdf.addPage(
              formato === 'termica' ? [80, 297] : undefined,
              'portrait'
            )
            const pageContent = doc.internal.pages[j]
            if (pageContent) {
              pdf.internal.pages[pdf.internal.pages.length - 1] = pageContent
            }
          }
        }
      }
      
      const fecha = new Date().toISOString().split('T')[0]
      const nombreArchivo = formato === 'termica'
        ? `facturas-${fecha}-${facturasSelec.length}-80mm.pdf`
        : `facturas-${fecha}-${facturasSelec.length}.pdf`
      pdf.save(nombreArchivo)
      
      alert(`✅ ${facturasSelec.length} facturas descargadas en un solo PDF`)
      
    } catch (error) {
      console.error('Error generando PDF combinado:', error)
      alert('Error al combinar PDFs. Descargando por separado...')
      
      for (const factura of facturasSelec) {
        await descargarPDF(factura)
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    cargarDatos()
    verificarBackend()
  }, [])

  async function cargarDatos() {
   await Promise.all([
      cargarFacturas(),
      cargarFacturasPendientes(),
      cargarSincronizaciones(),
      cargarConfiguracion()
    ])
    
    // ⭐ Verificar cambio de año (solo al cargar la página)
    await verificarYActualizarAnio()
  }

  async function verificarBackend() {
    const activo = await verificarBackendVeriFactu()
    setBackendActivo(activo)
    if (!activo) {
      console.warn('⚠️ Backend VeriFactu no está ejecutándose')
    }
  }

  async function cargarFacturas() {
    const { data, error } = await supabase
      .from('facturas')
      .select(`
        *,
        lineas:factura_lineas(*)
      `)
      .order('fecha_emision', { ascending: false })
    
    if (error) {
      console.error('Error cargando facturas:', error)
      setFacturas([])
      return
    }
    
    const facturasConLineas = (data || []).map(f => ({
      ...f,
      lineas: f.lineas || []
    }))
    
    setFacturas(facturasConLineas)
  }

    // ⭐ DETECCIÓN AUTOMÁTICA DE CAMBIO DE AÑO
  async function verificarYActualizarAnio() {
    try {
      // 1. Obtener año actual del sistema
      const anioActual = new Date().getFullYear().toString()
      
      // 2. Obtener año configurado en la BD
      const { data: config } = await supabase
        .from('configuracion')
        .select('serie_factura')
        .limit(1)
        .single()
      
      if (!config) return
      
      const anioConfigurado = config.serie_factura
      
      // 3. Si son diferentes, preguntar al usuario
      if (anioConfigurado !== anioActual) {
        const cambiar = confirm(
          `🎉 ¡FELIZ AÑO NUEVO!\n\n` +
          `El sistema detectó que estamos en ${anioActual}.\n` +
          `La numeración actual es: ${anioConfigurado}/XXX\n\n` +
          `¿Desea resetear la numeración a ${anioActual}/1?\n\n` +
          `(Recomendado: SÍ, a menos que tengas facturas pendientes de ${anioConfigurado})`
        )
        
        if (cambiar) {
          console.log(`🔄 Reseteando numeración al año ${anioActual}...`)
          
          // 4. Llamar a la función SQL que ya existe
          const { error } = await supabase.rpc('reset_numeracion_anual', {
            p_nuevo_anio: anioActual
          })
          
          if (error) {
            console.error('Error reseteando año:', error)
            alert('⚠️ Error al resetear numeración. Contacta con soporte.')
            return
          }
          
          // 5. Recargar configuración
          await cargarConfiguracion()
          
          alert(
            `✅ ¡NUMERACIÓN ACTUALIZADA!\n\n` +
            `La próxima factura será: ${anioActual}/1\n\n` +
            `El cambio se ha guardado automáticamente.`
          )
          
          console.log(`✅ Numeración reseteada a ${anioActual}/1`)
        } else {
          console.log('⏭️ Usuario decidió no cambiar la numeración aún')
        }
      }
    } catch (error) {
      console.error('Error verificando año:', error)
      // No mostrar error al usuario, es una verificación silenciosa
    }
  }

  async function cargarFacturasPendientes() {
    const { data } = await supabase
      .from('facturas_pendientes')
      .select('*')
    
    setFacturasPendientes(data || [])
  }

  async function cargarSincronizaciones() {
    const { data } = await supabase
      .from('sincronizaciones')
      .select('*')
    
    setSincronizaciones(data || [])
  }

  async function cargarConfiguracion() {
    const { data, error } = await supabase
      .from('configuracion')
      .select('*')
      .limit(1)
      .single()
    
    if (error) {
      console.error('Error cargando configuración:', error)
      setConfiguracion({
        nombre_empresa: 'Panadería Hermanos Alonso S.L.',
        cif: '',
        direccion: '',
        cp: '',
        poblacion: '',
        provincia: '',
        telefono: '',
        email: '',
        serie_factura: '2026'  // ⬅️ AÑADIR ESTA LÍNEA
      })
    } else {
      console.log('✅ Configuración cargada:', data)
      setConfiguracion(data || {})
    }
  }

  function verificarSincronizacion() {
    const ahora = new Date()
    const advertencias = []
    
    ;['Ruta 1', 'Ruta 2', 'Movil'].forEach(usuario => {
      const sync = sincronizaciones.find(s => s.usuario === usuario)
      if (sync) {
        const ultimaSync = new Date(sync.ultima_sincronizacion)
        const horasDesdeSync = (ahora - ultimaSync) / (1000 * 60 * 60)
        
        if (horasDesdeSync > 18) {
          advertencias.push({
            usuario,
            horas: Math.floor(horasDesdeSync)
          })
        }
      }
    })
    
    return advertencias
  }

  async function generarFacturas() {
    const advertencias = verificarSincronizacion()
    
    if (advertencias.length > 0) {
      const mensaje = `⚠️ ADVERTENCIA: Los siguientes usuarios no han sincronizado en más de 18h:\n\n` +
        advertencias.map(a => `• ${a.usuario}: ${a.horas}h sin sincronizar`).join('\n') +
        `\n\n¿Desea generar las facturas de todas formas?`
      
      if (!confirm(mensaje)) return
    }
    
    setLoading(true)
    setMostrarGeneracion(true)
    
    try {
      const facturasGeneradas = await generarFacturasInterna()
      
      alert(`✅ ${facturasGeneradas.length} facturas generadas correctamente`)
      await cargarDatos()
      
    } catch (error) {
      console.error('Error en generación:', error)
      alert('Error generando facturas: ' + error.message)
    } finally {
      setLoading(false)
      setMostrarGeneracion(false)
    }
  }

  // ⭐ FUNCIÓN COMPLETA: generarFacturasInterna - CORREGIDA
  async function generarFacturasInterna() {
    const facturasGeneradas = []
    
    for (const pendiente of facturasPendientes) {
      try {
        // CORRECCIÓN: Usar tabla 'deliveries' en lugar de 'albaranes'
        const { data: albaranes } = await supabase
          .from('deliveries')
          .select(`*, delivery_lines(*)`)
          .eq('client_id', pendiente.client_id)
          .gte('fecha', pendiente.periodo_inicio)
          .lte('fecha', pendiente.periodo_fin)
        
        if (!albaranes || albaranes.length === 0) {
          console.log(`⏭️ Cliente ${pendiente.alias}: Sin albaranes en el periodo`)
          continue
        }
        
        const { data: cliente } = await supabase
          .from('clients')
          .select('*')
          .eq('id', pendiente.client_id)
          .single()
        
        const lineasMap = {}
        albaranes.forEach(albaran => {
          albaran.delivery_lines.forEach(linea => {
            const key = `${linea.product_id}-${linea.precio_unit}`
            if (!lineasMap[key]) {
              lineasMap[key] = {
                product_id: linea.product_id,
                cantidad: 0,
                precio_con_iva: linea.precio_unit,
                iva_pct: linea.iva_pct,
                descuento_aplicable: linea.descuento_aplicable
              }
            }
            lineasMap[key].cantidad += linea.cantidad_entregada - (linea.cantidad_devuelta || 0)
          })
        })

        const lineas = Object.values(lineasMap).filter(l => l.cantidad > 0)

        if (lineas.length === 0) {
          console.log(`⏭️ Cliente ${pendiente.alias}: Sin líneas válidas`)
          continue
        }

        const { data: productos } = await supabase
          .from('products')
          .select('*')
          .in('id', lineas.map(l => l.product_id))

        function quitarIvaRE(precioBruto, iva_pct, tieneRE) {
          const iva = iva_pct / 100
          const re = tieneRE ? (iva_pct === 10 ? 0.014 : iva_pct === 4 ? 0.005 : 0.052) : 0
          return precioBruto / (1 + iva + re)
        }

        function aplicarMargen(precioSinIvaRE, margenPct) {
          return precioSinIvaRE * (1 - margenPct / 100)
        }

        const lineasCalculadas = []
        const gruposPorIva = {}

        lineas.forEach(linea => {
          const producto = productos.find(p => p.id === linea.product_id)
          const ivaPct = Number(linea.iva_pct)
          const key = String(ivaPct)
          
          if (!gruposPorIva[key]) gruposPorIva[key] = []
          
          const cantidad = Number(linea.cantidad)
          const precioBruto = Number(linea.precio_con_iva)
          const tieneRE = Boolean(cliente.recargo_equivalencia)
          const margenCliente = Number(cliente.descuento_porcentaje || 0)
          
          const precioSinIvaRE = quitarIvaRE(precioBruto, ivaPct, tieneRE)
          const precioNeto = linea.descuento_aplicable
            ? aplicarMargen(precioSinIvaRE, margenCliente)
            : precioSinIvaRE
          
          const baseLinea = precioNeto * cantidad
          
          gruposPorIva[key].push({
            product_id: linea.product_id,
            concepto: producto?.nombre || 'Producto',
            cantidad: cantidad,
            precio_unit: precioNeto,
            base: baseLinea,
            iva_pct: ivaPct,
            descuento_aplicable: linea.descuento_aplicable
          })
        })

        const desglosePorIva = []
        let baseTotal = 0
        let ivaTotal = 0
        let reTotal = 0

        Object.keys(gruposPorIva).sort().forEach(ivaPctKey => {
          const lineasGrupo = gruposPorIva[ivaPctKey]
          const ivaPct = Number(ivaPctKey)
          
          const baseGrupo = lineasGrupo.reduce((s, l) => s + l.base, 0)
          const ivaGrupo = baseGrupo * (ivaPct / 100)
          const rePct = cliente.recargo_equivalencia ? obtenerRecargoEquivalencia(ivaPct) : 0
          const reGrupo = baseGrupo * (rePct / 100)
          
          desglosePorIva.push({
            iva_pct: ivaPct,
            base: Number(baseGrupo.toFixed(2)),
            iva: Number(ivaGrupo.toFixed(2)),
            re_pct: rePct,
            re: Number(reGrupo.toFixed(2))
          })
          
          baseTotal += baseGrupo
          ivaTotal += ivaGrupo
          reTotal += reGrupo
          
          lineasGrupo.forEach(l => lineasCalculadas.push({ ...l, total: l.base }))
        })

        const totales = {
          base: Number(baseTotal.toFixed(2)),
          iva: Number(ivaTotal.toFixed(2)),
          re: Number(reTotal.toFixed(2)),
          total: Number((baseTotal + ivaTotal + reTotal).toFixed(2)),
          desglose_iva: desglosePorIva
        }
        
        if (totales.base === 0) {
          console.error(`❌ Cliente ${pendiente.alias}: BASE = 0, SALTANDO`)
          continue
        }
        const serieActual = configuracion?.serie_factura || '2026'

        const { data: numeroData, error: errorNumero } = await supabase.rpc('get_next_factura_numero', { p_serie: serieActual })
        if (errorNumero) throw new Error('No se pudo obtener número de factura')
        const numero = numeroData || 1
        
        const { data: nuevaFactura, error: errorFactura } = await supabase
          .from('facturas')
          .insert({
            serie: serieActual,
            numero: numero,
            client_id: cliente.id,
            cliente_nombre: cliente.razon_social,
            cliente_cif: cliente.cif,
            cliente_direccion: cliente.direccion,
            cliente_email: cliente.email,
            periodo_inicio: pendiente.periodo_inicio,
            periodo_fin: pendiente.periodo_fin,
            fecha_emision: new Date().toISOString().split('T')[0],
            tipo_periodo: cliente.periodo_facturacion,
            base_imponible: totales.base,
            iva: totales.iva,
            iva_pct: 10,
            total: totales.total,
            recargo_equivalencia: totales.re,
            re_pct: cliente.recargo_equivalencia ? 5.2 : 0,
            desglose_iva: totales.desglose_iva,
            estado_verifactu: 'no_enviada'
          })
          .select()
          .single()
        
        if (errorFactura) throw errorFactura
        
        const lineasFactura = lineasCalculadas.map(l => ({
          factura_id: nuevaFactura.id,
          concepto: l.concepto,
          cantidad: l.cantidad,
          precio_unit: l.precio_unit,
          base: Number(l.base.toFixed(2)),
          iva_pct: l.iva_pct,
          total: Number(l.total.toFixed(2))
        }))
        
        const { error: errorLineas } = await supabase
          .from('factura_lineas')
          .insert(lineasFactura)
        
        if (errorLineas) throw errorLineas
        
        facturasGeneradas.push({
          ...nuevaFactura,
          lineas: lineasFactura
        })
        
        console.log(`✅ Factura ${numero} generada para ${cliente.alias}`)
        
      } catch (error) {
        console.error(`❌ Error generando factura para ${pendiente.alias}:`, error)
      }
    }
    
    return facturasGeneradas
  }

  // ⭐ FUNCIÓN: procesarFacturasCompleto - CORREGIDA
  async function procesarFacturasCompleto() {
    const advertencias = verificarSincronizacion()
    
    if (advertencias.length > 0) {
      const mensaje = `⚠️ ADVERTENCIA: Los siguientes usuarios no han sincronizado en más de 18h:\n\n` +
        advertencias.map(a => `• ${a.usuario}: ${a.horas}h sin sincronizar`).join('\n') +
        `\n\n¿Desea continuar con el proceso completo?`
      
      if (!confirm(mensaje)) return
    }

    const pasos = backendActivo
      ? `1. Generar ${facturasPendientes.length} facturas\n2. Enviar a VeriFactu/AEAT\n3. Enviar PDFs a gestoría\n4. Imprimir tickets 80mm\n5. Enviar emails a clientes (si tienen)`
      : `1. Generar ${facturasPendientes.length} facturas\n2. ⚠️ VeriFactu omitido (usa la app de escritorio para enviar a AEAT)\n3. Enviar PDFs a gestoría\n4. Imprimir tickets 80mm\n5. Enviar emails a clientes (si tienen)`

    if (!confirm(
      `🚀 PROCESO COMPLETO DE FACTURACIÓN\n\n` +
      `Se realizarán las siguientes acciones:\n` +
      pasos + `\n\n¿Continuar?`
    )) return

    setLoading(true)
    setMostrarProgresoCompleto(true)

    const progreso = {
      paso: 1,
      total: 5,
      facturasGeneradas: [],
      exitosVeriFactu: 0,
      fallosVeriFactu: [],
      exitosGestoria: 0,
      fallosGestoria: [],
      exitosImpresion: 0,
      fallosImpresion: [],
      exitosEmail: 0,
      fallosEmail: [],
      sinEmail: []
    }

    try {
      // PASO 1: GENERAR FACTURAS
      setProgresoInfo({ ...progreso, mensaje: 'Generando facturas...' })
      console.log('\n🚀 ===== PASO 1: GENERAR FACTURAS =====')
      
      const facturasGeneradas = await generarFacturasInterna()
      progreso.facturasGeneradas = facturasGeneradas
      
      if (facturasGeneradas.length === 0) {
        alert('No se generaron facturas. Proceso cancelado.')
        return
      }

      console.log(`✅ ${facturasGeneradas.length} facturas generadas`)
      
      // PASO 2: ENVIAR A VERIFACTU
      progreso.paso = 2
      setProgresoInfo({ ...progreso, mensaje: 'Enviando a VeriFactu...' })
      console.log('\n📤 ===== PASO 2: ENVIAR A VERIFACTU =====')

      if (backendActivo) {
        for (const factura of facturasGeneradas) {
          try {
            console.log(`📤 Enviando ${factura.serie}-${factura.numero}...`)
            await enviarFacturaVeriFactu(factura.id)
            progreso.exitosVeriFactu++
            console.log(`✅ ${factura.serie}-${factura.numero} enviada a VeriFactu`)
          } catch (error) {
            console.error(`❌ Error VeriFactu en ${factura.serie}-${factura.numero}:`, error)
            progreso.fallosVeriFactu.push(`${factura.serie}-${factura.numero}: ${error.message}`)
          }
        }
        
        // ⭐ AÑADIR AQUÍ: RECARGAR FACTURAS CON QR ACTUALIZADO
        console.log('🔄 Recargando facturas con datos de VeriFactu...')
        const facturasIds = facturasGeneradas.map(f => f.id)
        
        const { data: facturasActualizadas } = await supabase
          .from('facturas')
          .select('*, lineas:factura_lineas(*)')
          .in('id', facturasIds)
        
        if (facturasActualizadas && facturasActualizadas.length > 0) {
          // Actualizar el array con las facturas que tienen QR
          progreso.facturasGeneradas = facturasActualizadas.map(f => ({
            ...f,
            lineas: f.lineas || []
          }))
          console.log(`✅ ${facturasActualizadas.length} facturas recargadas con QR`)
        }
        // Fin de la corrección
        
      } else {
        console.warn('⚠️ Backend VeriFactu no disponible, saltando paso')
      }

      // PASO 3: ENVIAR A GESTORÍA
      progreso.paso = 3
      setProgresoInfo({ ...progreso, mensaje: 'Enviando PDFs a gestoría...' })
      console.log('\n📧 ===== PASO 3: ENVIAR A GESTORÍA =====')

      if (configuracion?.email_gestoria) {
        try {
          console.log('Preparando archivos para gestoría...')
          // Ahora progreso.facturasGeneradas tiene los QR actualizados ✅
          const archivos = await prepararArchivosGestoria(progreso.facturasGeneradas, generarPDFFactura)
          
          console.log('Enviando email a gestoría...')
          await enviarFacturasAGestoria(
            progreso.facturasGeneradas,
            archivos,
            configuracion.email_gestoria
          )
          
          progreso.exitosGestoria = progreso.facturasGeneradas.length
          console.log(`✅ ${progreso.facturasGeneradas.length} facturas enviadas a gestoría`)
        } catch (error) {
          console.error('❌ Error enviando a gestoría:', error)
          progreso.fallosGestoria.push(`Todas: ${error.message}`)
        }
      } else {
        console.warn('⚠️ No hay email de gestoría configurado, saltando paso')
      }

     // PASO 4: IMPRIMIR TICKETS 80MM (SILENCIOSO)
    progreso.paso = 4
    setProgresoInfo({ ...progreso, mensaje: 'Imprimiendo tickets 80mm...' })
    console.log('\n🖨️ ===== PASO 4: IMPRIMIR TICKETS 80MM =====')

    try {
      const resultado = await imprimirFacturasMasivo(progreso.facturasGeneradas)
      progreso.exitosImpresion = resultado.exitosas
      
      if (resultado.fallidas > 0) {
        progreso.fallosImpresion.push(`${resultado.fallidas} facturas fallidas`)
      }
      
      console.log(`✅ ${resultado.exitosas} facturas impresas`)
    } catch (error) {
      console.error('❌ Error imprimiendo:', error)
      progreso.fallosImpresion.push(`Error general: ${error.message}`)
    }
    // PASO 5: ENVIAR EMAILS A CLIENTES
    progreso.paso = 5
    setProgresoInfo({ ...progreso, mensaje: 'Enviando emails a clientes...' })
    console.log('\n📨 ===== PASO 5: ENVIAR EMAILS A CLIENTES =====')

    for (const factura of progreso.facturasGeneradas) {  // ✅ Usar progreso.facturasGeneradas
      const { data: cliente } = await supabase
        .from('clients')
        .select('email, alias')
        .eq('id', factura.client_id)
        .single()
      
      if (cliente?.email && cliente.email.includes('@')) {
        try {
          console.log(`📨 Enviando a ${cliente.alias} (${cliente.email})...`)
          const pdfDoc = await generarPDFFactura(factura, configuracion)
          const pdfBytes = pdfDoc.output('arraybuffer')
          const blob = new Blob([pdfBytes], { type: 'application/pdf' })
          
          await enviarFacturaACliente(factura, blob)
          progreso.exitosEmail++
          console.log(`✅ Email enviado a ${cliente.alias}`)
        } catch (error) {
          console.error(`❌ Error email a ${cliente.alias}:`, error)
          progreso.fallosEmail.push(`${cliente.alias}: ${error.message}`)
        }
      } else {
        progreso.sinEmail.push(cliente?.alias || factura.cliente_nombre)
      }
    }

      // RESUMEN FINAL
      console.log('\n✅ ===== PROCESO COMPLETADO =====')
      mostrarResumenFinal(progreso)
      await cargarDatos()

    } catch (error) {
      console.error('❌ ERROR FATAL:', error)
      alert('Error en el proceso: ' + error.message)
    } finally {
      setLoading(false)
      setMostrarProgresoCompleto(false)
    }
  }

  function mostrarResumenFinal(progreso) {
    let mensaje = `✅ PROCESO COMPLETADO\n\n`
    mensaje += `📊 RESUMEN:\n`
    mensaje += `• Facturas generadas: ${progreso.facturasGeneradas.length}\n`
    mensaje += `• Enviadas VeriFactu: ${progreso.exitosVeriFactu}/${progreso.facturasGeneradas.length}\n`
    mensaje += `• Enviadas gestoría: ${progreso.exitosGestoria}/${progreso.facturasGeneradas.length}\n`
    mensaje += `• Tickets impresos: ${progreso.exitosImpresion}/${progreso.facturasGeneradas.length}\n`
    mensaje += `• Emails enviados: ${progreso.exitosEmail}/${progreso.facturasGeneradas.length}\n`
    
    if (progreso.sinEmail.length > 0) {
      mensaje += `\n⚠️ Clientes sin email (${progreso.sinEmail.length}):\n`
      progreso.sinEmail.slice(0, 5).forEach(c => mensaje += `  • ${c}\n`)
      if (progreso.sinEmail.length > 5) {
        mensaje += `  ... y ${progreso.sinEmail.length - 5} más\n`
      }
    }
    
    if (progreso.fallosVeriFactu.length > 0) {
      mensaje += `\n❌ ERRORES VeriFactu (${progreso.fallosVeriFactu.length}):\n`
      progreso.fallosVeriFactu.slice(0, 3).forEach(e => mensaje += `  • ${e}\n`)
    }
    
    if (progreso.fallosGestoria.length > 0) {
      mensaje += `\n❌ ERRORES Gestoría (${progreso.fallosGestoria.length}):\n`
      progreso.fallosGestoria.slice(0, 3).forEach(e => mensaje += `  • ${e}\n`)
    }
    
    if (progreso.fallosEmail.length > 0) {
      mensaje += `\n❌ ERRORES Emails (${progreso.fallosEmail.length}):\n`
      progreso.fallosEmail.slice(0, 3).forEach(e => mensaje += `  • ${e}\n`)
    }
    
    alert(mensaje)
  }

  async function descargarPDF(factura, formato = 'a4') {
    try {
      const doc = await generarPDFFactura(factura, configuracion, { formato })
      const nombreArchivo = formato === 'termica' 
        ? `factura-${factura.serie}-${factura.numero}-80mm.pdf`
        : `factura-${factura.serie}-${factura.numero}.pdf`
      doc.save(nombreArchivo)
    } catch (error) {
      alert('Error generando PDF: ' + error.message)
    }
  }

    async function imprimirFacturaBoton(factura) {
    const opcion = confirm(
      `¿Qué formato deseas imprimir?\n\n` +
      `OK = A4 (normal)\n` +
      `Cancelar = Térmica 80mm (ESC/POS)`
    )
    
    try {
      if (opcion) {
        // A4 - usar PDF
        const doc = await generarPDFFactura(factura, configuracion, { formato: 'a4' })
        window.open(doc.output('bloburl'), '_blank')
      } else {
        // 80mm - usar ESC/POS nativo
        await imprimirFactura(factura, configuracion)
      }
    } catch (error) {
      console.error('Error imprimiendo:', error)
      alert('Error al imprimir: ' + error.message)
    }
  }

  async function imprimirFacturasMasivo(facturas) {
    let exitosas = 0
    let fallidas = 0
    
    for (const factura of facturas) {
      try {
        await imprimirFactura(factura, configuracion)
        exitosas++
        console.log(`✅ Factura ${factura.serie}-${factura.numero} impresa`)
      } catch (error) {
        fallidas++
        console.error(`❌ Error en ${factura.serie}-${factura.numero}:`, error)
      }
    }
    
    return { exitosas, fallidas }
  }

  async function guardarYEnviarPDF(factura, tipo) {
  try {
    // Primero, cargar la factura completa con líneas desde la BD
    const { data: facturaCompleta, error } = await supabase
      .from('facturas')
      .select('*, lineas:factura_lineas(*)')
      .eq('id', factura.id)
      .single()
    
    if (error || !facturaCompleta) {
      throw new Error('No se pudo cargar la factura completa')
    }
    
    // Asegurar que tenga líneas
    facturaCompleta.lineas = facturaCompleta.lineas || []
    
    if (tipo === 'cliente') {
      // Generar PDF y enviar a cliente
      const pdfDoc = await generarPDFFactura(facturaCompleta, configuracion)
      const pdfBytes = pdfDoc.output('arraybuffer')
      const blob = new Blob([pdfBytes], { type: 'application/pdf' })
      
      await enviarFacturaACliente(facturaCompleta, blob)
      
      console.log(`✅ Factura ${facturaCompleta.serie}-${facturaCompleta.numero} enviada a cliente`)
      
    } else if (tipo === 'gestoria') {
      // Preparar archivos (Excel + PDF) y enviar a gestoría
      const archivos = await prepararArchivosGestoria([facturaCompleta], generarPDFFactura)
      await enviarFacturasAGestoria([facturaCompleta], archivos, configuracion.email_gestoria)
      
      console.log(`✅ Factura ${facturaCompleta.serie}-${facturaCompleta.numero} enviada a gestoría`)
    }
    
    await cargarFacturas()
    alert(`✅ Factura enviada correctamente a ${tipo}`)
    
  } catch (error) {
    console.error('Error:', error)
    alert(`❌ Error: ${error.message}`)
    throw error
  }
}

  async function enviarUnaFacturaVeriFactu(factura) {
    console.log('🚀 Enviando factura individual:', factura.serie, factura.numero)
    
    if (!backendActivo) {
      console.error('❌ Backend no activo')
      alert('⚠️ Backend VeriFactu no disponible')
      return
    }
    
    if (!confirm(`¿Enviar factura ${factura.serie}-${factura.numero} a VeriFactu/AEAT?`)) {
      console.log('❌ Usuario canceló')
      return
    }
    
    setEnviandoVeriFactu(true)
    console.log('📤 Enviando ID:', factura.id)
    
    try {
      const resultado = await enviarFacturaVeriFactu(factura.id)
      console.log('✅ Respuesta:', resultado)
      
      if (resultado.success) {
        alert(`✅ Factura enviada correctamente\n\nCSV: ${resultado.factura.csv}`)
        await cargarFacturas()
      }
    } catch (error) {
      console.error('❌ Error completo:', error)
      alert(`❌ Error: ${error.message}`)
    } finally {
      setEnviandoVeriFactu(false)
      console.log('🏁 Envío finalizado')
    }
  }

  async function enviarPendientesVeriFactu() {
    console.log('🚀 Iniciando envío a VeriFactu...')
    
    if (!backendActivo) {
      console.error('❌ Backend no activo')
      alert('⚠️ Backend VeriFactu no disponible. Verifica que esté ejecutándose en http://localhost:3001')
      return
    }
    
    const pendientes = facturas.filter(f => f.estado_verifactu === 'no_enviada')
    console.log(`📋 Facturas pendientes: ${pendientes.length}`)
    
    if (pendientes.length === 0) {
      alert('No hay facturas pendientes de enviar')
      return
    }
    
    if (!confirm(`¿Enviar ${pendientes.length} facturas a VeriFactu/AEAT?\n\nEsto puede tardar varios minutos.`)) {
      console.log('❌ Usuario canceló')
      return
    }
    
    setEnviandoVeriFactu(true)
    console.log('⏳ Enviando lote...')
    
    try {
      const ids = pendientes.map(f => f.id)
      console.log('📤 IDs a enviar:', ids)
      
      const resultado = await enviarLoteVeriFactu(ids)
      console.log('✅ Resultado:', resultado)
      
      alert(`✅ Proceso completado\n\n` +
            `Exitosas: ${resultado.exitosas}\n` +
            `Fallidas: ${resultado.fallidas}`)
      
      await cargarFacturas()
    } catch (error) {
      console.error('❌ Error completo:', error)
      alert(`❌ Error: ${error.message}`)
    } finally {
      setEnviandoVeriFactu(false)
      console.log('🏁 Proceso finalizado')
    }
  }

  const facturasFiltradas = facturas.filter(f => {
    if (filtro === 'pendientes') return f.estado_verifactu === 'no_enviada'
    if (filtro === 'enviadas') return f.estado_verifactu === 'enviada'
    return true
  })

  const advertenciasSinc = verificarSincronizacion()

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>📄 Facturación</h1>
          <p>Gestión de facturas y envío a Hacienda</p>
          {!backendActivo && (
            <div style={{ fontSize: '0.875rem', color: 'var(--warn)', marginTop: '0.25rem' }}>
              ⚠️ Backend VeriFactu desconectado
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <button 
            onClick={() => setMostrarTotalesSemana(true)}
            className="btn-secondary"
          >
            <Calendar size={18} />
            Semana Anterior
          </button>
          <button 
            onClick={() => exportarFacturasAExcel(facturas)}
            className="btn-secondary"
          >
            <FileSpreadsheet size={18} />
            Excel
          </button>
          <button 
            onClick={() => setMostrarFacturaIndividual(true)}
            className="btn-secondary"
          >
            <Plus size={18} />
            Factura Individual
          </button>
          <button
            onClick={procesarFacturasCompleto}
            disabled={loading || facturasPendientes.length === 0}
            className="btn-primary"
            style={{
              fontSize: '1rem',
              padding: '0.75rem 1.5rem'
            }}
          >
            <Plus size={20} />
            🚀 Generar y procesar ({facturasPendientes.length})
          </button>
        </div>
      </div>

      {advertenciasSinc.length > 0 && (
        <div style={{
          padding: '1rem',
          background: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid var(--warn)',
          borderRadius: '8px',
          marginBottom: '1rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <AlertTriangle size={20} color="var(--warn)" />
            <strong>Advertencia: Base de datos desactualizada</strong>
          </div>
          {advertenciasSinc.map(a => (
            <div key={a.usuario}>• {a.usuario}: {a.horas}h sin sincronizar</div>
          ))}
        </div>
      )}

      {facturasSeleccionadas.length > 0 && (
        <div style={{ 
          marginBottom: '1rem',
          padding: '1rem',
          background: 'var(--accent-bg)',
          border: '1px solid var(--accent)',
          borderRadius: '8px',
          display: 'flex',
          gap: '0.5rem',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <span style={{ fontWeight: 'bold' }}>
            {facturasSeleccionadas.length} factura(s) seleccionada(s)
          </span>
          <button
            onClick={() => accionMasiva('descargar')}
            className="btn-secondary"
            disabled={loading}
          >
            <Download size={16} />
            Descargar
          </button>
          <button
            onClick={() => accionMasiva('gestoria')}
            className="btn-secondary"
            disabled={loading}
          >
            <Mail size={16} />
            Enviar a gestoría
          </button>
          <button
            onClick={() => accionMasiva('imprimir')}
            className="btn-secondary"
            disabled={loading}
          >
            <Printer size={16} />
            Imprimir todas
          </button>
          <button
            onClick={() => accionMasiva('clientes')}
            className="btn-secondary"
            disabled={loading}
          >
            <Send size={16} />
            Enviar a clientes
          </button>
          <button
            onClick={() => setFacturasSeleccionadas([])}
            className="btn-secondary"
            style={{ marginLeft: 'auto' }}
          >
            Limpiar selección
          </button>
        </div>
      )}

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem',
        marginBottom: '1.5rem'
      }}>
        <div className="card" style={{ padding: '1rem' }}>
          <div style={{ fontSize: '0.875rem', color: 'var(--muted)' }}>Facturas pendientes</div>
          <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--warn)' }}>
            {facturasPendientes.length}
          </div>
        </div>
        <div className="card" style={{ padding: '1rem' }}>
          <div style={{ fontSize: '0.875rem', color: 'var(--muted)' }}>Total facturas</div>
          <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>
            {facturas.length}
          </div>
        </div>
        <div className="card" style={{ padding: '1rem' }}>
          <div style={{ fontSize: '0.875rem', color: 'var(--muted)' }}>Enviadas VeriFactu</div>
          <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--accent)' }}>
            {facturas.filter(f => f.estado_verifactu === 'enviada').length}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        {['todas', 'pendientes', 'enviadas'].map(f => (
          <button
            key={f}
            onClick={() => setFiltro(f)}
            style={{
              padding: '0.5rem 1rem',
              background: filtro === f ? 'var(--accent)' : 'var(--bg-secondary)',
              color: filtro === f ? '#000' : 'var(--fg)',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              textTransform: 'capitalize'
            }}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="tabla-wrapper">
        <table className="tabla-lineas">
          <thead>
            <tr>
              <th style={{ width: '40px' }}>
                <input
                  type="checkbox"
                  checked={facturasSeleccionadas.length === facturasFiltradas.length && facturasFiltradas.length > 0}
                  onChange={seleccionarTodas}
                />
              </th>
              <th>Nº Factura</th>
              <th>Cliente</th>
              <th>Fecha</th>
              <th>Periodo</th>
              <th style={{ textAlign: 'right' }}>Total</th>
              <th style={{ textAlign: 'center' }}>Estado</th>
              <th style={{ textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {facturasFiltradas.map(factura => (
              <tr key={factura.id}>
                <td style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={facturasSeleccionadas.includes(factura.id)}
                    onChange={() => toggleSeleccion(factura.id)}
                  />
                </td>
                <td style={{ fontWeight: 'bold' }}>
                  {factura.serie}-{factura.numero}
                </td>
                <td>{factura.cliente_nombre}</td>
                <td>{new Date(factura.fecha_emision).toLocaleDateString('es-ES')}</td>
                <td style={{ fontSize: '0.875rem' }}>
                  {new Date(factura.periodo_inicio).toLocaleDateString('es-ES')} - {new Date(factura.periodo_fin).toLocaleDateString('es-ES')}
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                  {factura.total.toFixed(2)}€
                </td>
                <td style={{ textAlign: 'center' }}>
                  {factura.estado_verifactu === 'enviada' && (
                    <CheckCircle size={18} color="var(--accent)" title="Enviada a VeriFactu" />
                  )}
                  {factura.estado_verifactu === 'no_enviada' && (
                    <XCircle size={18} color="var(--warn)" title="Pendiente de envío" />
                  )}
                  {factura.estado_verifactu === 'error' && (
                    <AlertTriangle size={18} color="var(--error)" title="Error en envío" />
                  )}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'center' }}>
                    <button
                      onClick={() => descargarPDF(factura)}
                      className="btn-icon"
                      title="Descargar PDF"
                    >
                      <Download size={16} />
                    </button>
                    <button
                      onClick={() => imprimirFacturaBoton(factura)}
                      className="btn-icon"
                      title="Imprimir (A4 o Térmica 80mm)"
                    >
                      <Printer size={16} />
                    </button>
                    <button
                    onClick={async () => {
                      try {
                        // Cargar factura completa con líneas
                        const { data: facturaCompleta } = await supabase
                          .from('facturas')
                          .select('*, lineas:factura_lineas(*)')
                          .eq('id', factura.id)
                          .single()
                        
                        if (facturaCompleta) {
                          facturaCompleta.lineas = facturaCompleta.lineas || []
                          
                          // Usar la misma función que para gestoría
                          const archivos = await prepararArchivosGestoria([facturaCompleta], generarPDFFactura)
                          
                          // Descargar solo el Excel
                          const url = URL.createObjectURL(archivos.excel)
                          const a = document.createElement('a')
                          a.href = url
                          a.download = `factura-${factura.serie}-${factura.numero}.xlsx`
                          a.click()
                          URL.revokeObjectURL(url)
                        }
                      } catch (error) {
                        console.error('Error:', error)
                        alert('Error al exportar: ' + error.message)
                      }
                    }}
                    className="btn-icon"
                    title="Exportar Excel detallado"
                  >
                    <FileSpreadsheet size={16} />
                  </button>

                    {factura.estado_verifactu === 'no_enviada' && (
                      <button
                        onClick={() => enviarUnaFacturaVeriFactu(factura)}
                        className="btn-icon"
                        title="Enviar a VeriFactu"
                        disabled={enviandoVeriFactu || !backendActivo}
                        style={{
                          background: backendActivo ? 'var(--accent)' : 'var(--muted)',
                          opacity: enviandoVeriFactu ? 0.5 : 1
                        }}
                      >
                        <CheckCircle size={16} />
                      </button>
                    )}
                    <button
                      onClick={() => guardarYEnviarPDF(factura, 'gestoria')}
                      className="btn-icon"
                      title="Enviar a gestoría"
                      disabled={loading}
                    >
                      <FileText size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {facturasFiltradas.length === 0 && (
        <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--muted)' }}>
          <FileText size={48} style={{ opacity: 0.3 }} />
          <p>No hay facturas {filtro === 'todas' ? '' : filtro}</p>
        </div>
      )}

      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'var(--bg)',
            padding: '2rem',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <RefreshCw size={48} className="spin" />
            <p style={{ marginTop: '1rem' }}>Procesando...</p>
          </div>
        </div>
      )}

      {mostrarProgresoCompleto && progresoInfo && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'var(--bg)',
            padding: '2rem',
            borderRadius: '12px',
            minWidth: '400px',
            maxWidth: '600px'
          }}>
            <h2>🚀 Procesando facturas...</h2>
            
            <div style={{ marginTop: '1.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                {progresoInfo.paso >= 1 ? '✅' : '⏳'} 
                <span style={{ opacity: progresoInfo.paso >= 1 ? 1 : 0.5 }}>
                  1. Generando facturas... {progresoInfo.paso >= 1 && `(${progresoInfo.facturasGeneradas.length})`}
                </span>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                {progresoInfo.paso > 2 ? '✅' : progresoInfo.paso === 2 ? '⏳' : '⏸️'}
                <span style={{ opacity: progresoInfo.paso >= 2 ? 1 : 0.5 }}>
                  2. Enviando a VeriFactu... {progresoInfo.paso > 2 && `(${progresoInfo.exitosVeriFactu})`}
                </span>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                {progresoInfo.paso > 3 ? '✅' : progresoInfo.paso === 3 ? '⏳' : '⏸️'}
                <span style={{ opacity: progresoInfo.paso >= 3 ? 1 : 0.5 }}>
                  3. Enviando a gestoría... {progresoInfo.paso > 3 && `(${progresoInfo.exitosGestoria})`}
                </span>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                {progresoInfo.paso > 4 ? '✅' : progresoInfo.paso === 4 ? '⏳' : '⏸️'}
                <span style={{ opacity: progresoInfo.paso >= 4 ? 1 : 0.5 }}>
                  4. Imprimiendo tickets 80mm... {progresoInfo.paso > 4 && `(${progresoInfo.exitosImpresion})`}
                </span>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                {progresoInfo.paso > 5 ? '✅' : progresoInfo.paso === 5 ? '⏳' : '⏸️'}
                <span style={{ opacity: progresoInfo.paso >= 5 ? 1 : 0.5 }}>
                  5. Enviando emails a clientes... {progresoInfo.paso > 5 && `(${progresoInfo.exitosEmail})`}
                </span>
              </div>
            </div>
            
            <div style={{ marginTop: '1.5rem' }}>
              <div style={{ fontSize: '0.875rem', color: 'var(--muted)', marginBottom: '0.5rem' }}>
                Progreso: {Math.round((progresoInfo.paso / progresoInfo.total) * 100)}%
              </div>
              <div style={{ 
                height: '8px', 
                background: 'var(--bg-secondary)', 
                borderRadius: '4px',
                overflow: 'hidden'
              }}>
                <div style={{
                  height: '100%',
                  width: `${(progresoInfo.paso / progresoInfo.total) * 100}%`,
                  background: 'var(--accent)',
                  transition: 'width 0.3s'
                }} />
              </div>
            </div>
          </div>
        </div>
      )}
      
      {mostrarFacturaIndividual && (
        <FacturaIndividual 
          onClose={() => setMostrarFacturaIndividual(false)}
          onFacturaCreada={async () => {
            await cargarFacturas()
          }}
        />
      )}

      {mostrarTotalesSemana && (
        <TotalesSemanaAnterior onClose={() => setMostrarTotalesSemana(false)} />
      )}

    </div>
  )
}
